import { EodSupportApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useEodLogs = () => {
  const [eodLogs] = useAPIAction(
    EodSupportApi,
    async (api, deviceId: string) => {
      let response = await api.eodLogs({
        deviceId: deviceId
      });
      console.log("RESPONSE of API is , ", (response))
      return {
        successMessages: [],
        data: response,
      };
    },
    {
      translationPrefix: "",
    }
  );
  return useCallback(async (deviceId: string) => {
    return await eodLogs(deviceId);
  }, [eodLogs]);
};
